// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__1VElG","load7":"Spinner_load7__G__mS"};